import React from 'react'

import Preloader from './Preloader'
import Button from '../../../Button'

import classes from './styles'

const Result = ({ currentResult, goToNextQuestion, isPreloaderDisplayed }) => (
  <div>
    {isPreloaderDisplayed ?
      <Preloader/>
      :
      <div className={classes.result}>
        <div className={classes.text}>
          {currentResult.text}
        </div>

        <div className={classes.controls}>
          <Button
            onClick={goToNextQuestion}
          >
            Дальше
          </Button>
        </div>
      </div>
    }
  </div>
)

Result.propTypes = {
  isPreloaderDisplayed: React.PropTypes.bool.isRequired,
  currentResult: React.PropTypes.object.isRequired,
  goToNextQuestion: React.PropTypes.func.isRequired,
}

export default Result


// WEBPACK FOOTER //
// ./src/components/Question/components/Result/Result.jsx